
import { Component, Prop, Vue } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import CreateFirmwareDialog from "./CreateFirmwareDialog.vue";
import { Firmware } from "@/api/dtos/Firmware.schema";
import * as firmwareApi from "@/api/firmwares";

@Component({
  components: {
    CreateFirmwareDialog,
    ContainerFrame,
  },
})
export default class FirmwaresTable extends Vue {
  @Prop({ default: 110 }) width!: number;
  @Prop({ default: 30 }) height!: number;

  searchQuery = "";
  firmwares: Firmware[] = [];

  dialogFirmware: Firmware = {
    name: "",
    description: "",
    hardwareType: "BIKE_PARK_BOX_CONTROLLER",
    versions: [],
    createdAt: ""
  };
  showCreateDialog = false;

  readonly headers: {
    text: string;
    value: string;
    align?: "start" | "center" | "end";
  }[] = [
    { text: "Name", value: "name" },
    { text: "Geräte-Typ", value: "hardwareType" },
    { text: "Versionen", value: "versions" },
    { text: "", value: "actions", align: "center" },
  ];

  async mounted(): Promise<void> {
    await this.loadFirmwares();
  }

  async loadFirmwares(): Promise<void> {
    this.firmwares = await firmwareApi.getFirmwares();
  }


  onCreate(){
    this.dialogFirmware = {
      name: "",
      description: "",
      hardwareType: "BIKE_PARK_BOX_CONTROLLER",
      versions: [],
      createdAt: ""
    };
    this.showCreateDialog = true;
  }

  closeDialog(): void {
    console.log("SCHLIE?EN");
    this.showCreateDialog = false;
  }

  async onDelete(id: number) {
    await firmwareApi.deleteFirmware(id);
    await this.loadFirmwares();
  }

  onEdit(firmware: Firmware) :void {
    this.dialogFirmware = firmware;
    this.showCreateDialog = true;
  }

  onRowClicked(firmware: Firmware): void {
    // placeholder – you can load details or open dialog here
    console.log("row clicked", firmware);
    this.$router.push(`firmware/${firmware.id}`)
    // e.g.:
    // this.clickedFirmware = details;
    // this.showDetailsDialog = true;
  }
  

  async onAddFirmware(firmware: Firmware){
    if(firmware.id == null){
      await firmwareApi.createFirmware(firmware);
    }else{
      await firmwareApi.updateFirmware(firmware);
    }
    this.showCreateDialog = false;
    await this.loadFirmwares();
  }
}
